module.exports = __webpack_public_path__ + "static/media/updated-file.32a15805.svg";